module.exports = __webpack_public_path__ + "img/Herz.f670ce85.svg";